import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { useMutation, useQueryClient } from '@tanstack/react-query'

interface useDeleteSweepstakeParams {
  id: number | null | undefined
}

interface useDeleteSweepstakeProps {
  onSuccess?: (data: undefined, variables: useDeleteSweepstakeParams) => void
  onError?: (error: Error, variables: useDeleteSweepstakeParams) => void
}

export const useDeleteAllSweepstakesInGroupById = ({
  onSuccess,
  onError,
}: useDeleteSweepstakeProps) => {
  const deleteAllSweepstakesInGroup = useTypedApiClient({
    path: '/admin/contests/{id}/allInGroup',
    method: 'delete',
  })
  const queryClient = useQueryClient()

  return useMutation<any, Error, useDeleteSweepstakeParams>({
    mutationFn: async ({ id }: useDeleteSweepstakeParams) => {
      await deleteAllSweepstakesInGroup({ id: Number(id) })
    },
    onSuccess: async (data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: ['/sweepstakes'],
      })
      onSuccess?.(data, variables)
    },
    onError,
  })
}
